import { Iri /* Iris */ } from '@/rec-cache/rec-cache-types'
import { Ontology } from './ontology'
import { constraintDefinitions } from './constraint-definitions.js'

const ontology = new Ontology()

// TODO Needed for the constructor when working on parameters... refactor
const self = this

// Parameters sources and targets are arrays of class type strings or Iris, label is a relationship type string or Iri.
// Parameters out- and inDegree are integers representing max individuals on source and target respectively.
// TODO after embedding into the constraints DB class the constructor is called with Iris or arrays thereof... consider refactor.
class Constraint {
  constructor(
    sources,
    relationship,
    targets,
    outDegree = null,
    inDegree = null
  ) {
    this._sources = sources.map((s) =>
      s instanceof Iri ? s : self.$wob.owl.iri(s)
    )
    this._relationship =
      relationship instanceof Iri
        ? relationship
        : self.$wob.owl.iri(relationship)
    this._targets = targets.map((t) =>
      t instanceof Iri ? t : self.$wob.owl.iri(t)
    )
    if (outDegree) this._outDegree = outDegree
    if (inDegree) this._inDegree = inDegree
  }
  get sources() {
    return this._sources
  }
  get targets() {
    return this._targets
  }
  get relationship() {
    return this._relationship
  }
  get outDegree() {
    return this._outDegree
  }
  set outDegree(degree) {
    this._outDegree = degree
  }
  get inDegree() {
    return this._inDegree
  }
  set inDegree(degree) {
    this._inDegree = degree
  }
  inSources(type) {
    return !!this._sources.find((s) => s.equals(type))
  }
}

/*
// TODO moved to the Iris defitions... remove after test
const recRealEstate = 'https://w3id.org/rec#RealEstate'
const recSpace = 'https://w3id.org/rec#Space'
const recBuilding = 'https://w3id.org/rec#Building'
const recSubBuilding = 'https://w3id.org/rec#SubBuilding'
const recLevel = 'https://w3id.org/rec#Level'
const brickSystem = 'https://brickschema.org/schema/Brick#System'
const brickEquipment = 'https://brickschema.org/schema/Brick#Equipment'
// TODO temporarily added as the loaded ontology uses the rec, nort brick, sensor equipments...
const brickSensorEquipment =
  'https://brickschema.org/schema/Brick#Sensor_Equipment'
const brickPoint = 'https://brickschema.org/schema/Brick#Point'
*/

// Utility class for describing the constraints.
// TODO substitute with support for reading/deducting/inferring the constraints from the ontology at a later stage...
class ConstraintSchema {
  constructor(
    sources,
    relationship,
    targets,
    outDegree = null,
    inDegree = null
  ) {
    this.sources = sources
    this.relationship = relationship
    this.targets = targets
    this.outDegree = outDegree
    this.inDegree = inDegree
  }
}

// Generate the constraints schema based on the generic definitions.
const constraintSchemas = constraintDefinitions.map(
  (def) =>
    new ConstraintSchema(
      def.sources,
      def.relation,
      def.targets,
      def.min,
      def.max
    )
)
/*
// TODO remove as tests have been udnertaken... 
const constraintSchemas = [
  new ConstraintSchema(
    [recRealEstate],
    Iris.recIncludes,
    [recBuilding],
    null,
    1
  ),
  new ConstraintSchema(
    [recLevel, recSubBuilding],
    Iris.recIsPartOf,
    [recBuilding],
    1,
    null
  ),
  new ConstraintSchema([recLevel], Iris.recIsPartOf, [recSubBuilding], 1, null),
  // TODO use of sensor_eq due to wrong ontology being loaded...
  new ConstraintSchema(
    [brickSystem],
    Iris.recIncludes,
    [brickEquipment, brickSensorEquipment],
    null,
    1
  ),
  new ConstraintSchema(
    [recBuilding],
    Iris.recIsLocationOf,
    [brickSystem],
    null,
    1
  ),
  // TODO aggregate with previous... ie join sources.
  new ConstraintSchema(
    [recSubBuilding],
    Iris.recIsLocationOf,
    [brickSystem],
    null,
    1
  ),
  // TODO use of sensor_eq due to wrong ontology being loaded...
  new ConstraintSchema(
    [brickPoint],
    Iris.brickIsPointOf,
    [brickEquipment, brickSensorEquipment],
    1,
    null
  ),
  new ConstraintSchema(
    [brickEquipment],
    Iris.brickFeeds,
    [brickEquipment, recSpace],
    null,
    null
  ),
]
*/

// Parameter namespaces is a Namespaces used for creating namespaced Iris.
// Parameter schema is used to temporarily seed the constraints DB.
// TODO see through reading the ontology, somehow...
class ConstraintsDB {
  constructor(namespaces, schemas = constraintSchemas) {
    this._constraints = schemas.map(
      ({ sources, relationship, targets, outDegree, inDegree }) =>
        new Constraint(
          sources.map((s) => new Iri(s, namespaces)),
          new Iri(relationship, namespaces),
          targets.map((t) => new Iri(t, namespaces)),
          outDegree,
          inDegree
        )
    )
  }
  get constraints() {
    return this._constraints
  }
  // Parameter type is an Iri.
  inSources(type) {
    return this._constraints.filter(({ sources }) =>
      sources
        .map((source) => ontology.subclasses(source).concat(source))
        .reduce((acc, a) => acc.concat(a), [])
        .find((s) => s.equals(type))
    )
  }
  // Parameter type is an Iri.
  inTargets(type) {
    console.log('IN TARGETS', type)
    return this._constraints.filter(({ targets }) =>
      targets
        .map((target) => ontology.subclasses(target).concat(target))
        .reduce((acc, a) => acc.concat(a), [])
        .find((t) => t.equals(type))
    )
  }
}

export { ConstraintsDB }
